import Lang from '/@/modules/core/app/services/Lang';

export function joinWithOxfordComma(array: string[]): string {
  if (array.length === 2) {
    return Lang.t('core.stringone-stringtwo-and', {
      stringOne: array[0],
      stringTwo: array[1]
    });
  }

  if (array.length > 1) {
    array[array.length - 1] = Lang.t('core.string-and', { string: array[array.length - 1] });
  }

  return array.join(', ');
}
